












import Vue from "vue";
export default Vue.extend({
  props: {
    x1: {
      type: Number,
    },
    x2: {
      type: Number,
    },
    y: {
      type: Number,
    },
    height: {
      type: Number,
      default: 5,
    },
    color: {
      type: String,
    },
  },

  computed: {
    _x1(): number {
      const x = this.x1 < this.x2 ? this.x1 : this.x2;
      return x + this.height / 2;
    },
    _x2(): number {
      const x = this.x1 < this.x2 ? this.x2 : this.x1;
      return x - this.height / 2;
    },
  },
});
